import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { useExternalRegisterImport } from "./externalRegisterImportProvider";
import {
  MetricChip,
  StageUnavailable,
  WorkflowCard,
} from "../shared/ExternalRegisterSettingsUi";
import {
  ParseErrorsTable,
  SampleRowsTable,
  SourceColumnsTable,
} from "./ExternalRegisterImportParseTables";

export const ParseResultsStage = () => {
  const { t } = useTranslation();
  const { parseResponse, hasHeader, setHeaderMode, setActiveStage, reviewReadonly } = useExternalRegisterImport();
  const hasParseErrors = Boolean(parseResponse?.parseErrors.length);

  return (
    <WorkflowCard title={t("externalRegister.import.parse.title")}>
      {parseResponse ? (
        <Stack spacing={2}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", md: "center" }}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <MetricChip label={t("externalRegister.import.parse.metrics.rows")} value={parseResponse.rowCount} />
              <MetricChip label={t("externalRegister.import.parse.metrics.columns")} value={parseResponse.columnCount} />
              <MetricChip label={t("externalRegister.import.parse.metrics.headerGuess")} value={parseResponse.hasHeaderGuess ? t("externalRegister.import.parse.metrics.yes") : t("externalRegister.import.parse.metrics.no")} />
              {hasParseErrors && <MetricChip label={t("externalRegister.import.parse.metrics.parseErrors")} value={parseResponse.parseErrors.length} />}
            </Stack>
            <FormControl
              size="small"
              sx={{
                width: { xs: "100%", md: 260 },
                maxWidth: { md: 260 },
                flexShrink: 0,
              }}
            >
              <InputLabel id="header-mode-label">{t("externalRegister.import.parse.form.headerMode")}</InputLabel>
              <Select
                labelId="header-mode-label"
                label={t("externalRegister.import.parse.form.headerMode")}
                value={hasHeader === null ? "" : hasHeader ? "header" : "no-header"}
                onChange={(event) => setHeaderMode(event.target.value === "header")}
                disabled={reviewReadonly}
              >
                <MenuItem value="header">{t("externalRegister.import.parse.form.options.hasHeader")}</MenuItem>
                <MenuItem value="no-header">{t("externalRegister.import.parse.form.options.noHeader")}</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          {hasParseErrors && <ParseErrorsTable />}
          <SourceColumnsTable />
          <SampleRowsTable />
          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={() => setActiveStage("mapping")}
              disabled={hasHeader === null || hasParseErrors}
            >
              {t("externalRegister.import.parse.buttons.nextMapping")}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <StageUnavailable message={t("externalRegister.import.parse.unavailable")} />
      )}
    </WorkflowCard>
  );
};
